import { HTMLAttributes, forwardRef } from 'react'
import { cn } from '@/utils/cn'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'bordered' | 'accent'
  /** Tailwind-Klasse für den linken Akzent-Rand (nur variant="accent"), z.B. "border-l-blue-400" */
  accentColor?: string
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = 'default', accentColor = 'border-l-gray-400', children, ...props }, ref) => {
    const variantStyles = {
      default: 'bg-white rounded-lg shadow-md',
      bordered: 'bg-white rounded-lg border border-gray-200',
      accent: `bg-white dark:bg-gray-800 rounded-xl shadow-sm border-l-4 ${accentColor}`,
    }

    return (
      <div
        ref={ref}
        className={cn(variantStyles[variant], 'p-4', className)}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Card.displayName = 'Card'
